import LTR from "@brand-icons/ploom/profile-family/profile-family-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ProfileFamilyIcon = iconFactory("ProfileFamilyIcon", LTR);
